const Colour = {
  // Pink1: {
  //   name: "pink",
  //   tmId: 10,
  //   primary: "#af3699",
  //   secondary: "#d751a4",
  //   tertiary: "#a8569a",
  //   forth: "#8C62A0",
  //   success: "#34994f",
  //   info: "#268DDD",
  //   danger: "#e55353",
  //   warning: "#f9a825",
  //   light: "#f8fbfb",
  //   inputFieldColor: '#364d64',
  //   inputFieldBorderColor: '#9e9e9e',
  //   tableBGColor: '#FFE7F0',
  //   tableBGColor1: "#B296BF",
  //   tableBGColor2: `rgb(227, 227, 227)`,
  //   tableCellHeadColor: "#000",
  //   inputLabelColor: 'rgba(0, 0, 0, 0.6)',
  //   white: "#fff",
  //   black: "#000",
  //   shadow1: "#c48aba",
  //   shadow2: "#cc4599",
  //   shadow3: "#db7bcb",
  //   bodyGray: "#eeeefa",
  //   bodyGray2: "#ffff",
  //   bodyGray1: "#F8FBFF",
  //   primaryRow: "#e8e9eb",
  //   sideBar1: "#C8087F",
  //   sideBarIcon: "#ffff",
  //   nav: "#F2F5F7",
  //   navF: "#293845",
  //   linkClr: "#1d79ff",
  //   activeRow: "#d751a4",
  //   papperBg: "#fff",
  // },
  Pink1: {
    name: "pink",
    tmId: 10,
    primary: "#af3699",
    secondary: "#d751a4",
    tertiary: "#a8569a",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9e9e9e',
    tableBGColor: '#E6CED7',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#c48aba",
    shadow2: "#cc4599",
    shadow3: "#db7bcb",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#e8e9eb",
    sideBar1: "#C8087F",
    sideBarIcon: "#ffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    activeRow: "#d751a4",
    papperBg: "#fff",
  },
  //sec pink dark
  Pink1Dark: {
    name: "D_pink",
    tmId: 910,
    primary: "#af3699",
    secondary: "#d751a4",
    tertiary: "#a8569a",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9e9e9e',
    tableBGColor: '#E6CED7',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#c48aba",
    shadow2: "#cc4599",
    shadow3: "#db7bcb",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#e8e9eb",
    sideBar1: "#C8087F",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    FontClr: "#fff",
    papperBg: "#121212",
    activeRow: "#d751a4",
  },

  //main pink
  Pink: {
    name: "pink",
    tmId: 1,
    primary: "#911B7C",
    secondary: "#C8087F",
    tertiary: "#a8569a",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9e9e9e',
    tableBGColor: '#E6CED7',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#a84c98",
    shadow2: "#cc4599",
    shadow3: "#db7bcb",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#e8e9eb",
    sideBar1: "#C8087F",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    papperBg: "#fff",
    activeRow: "#d751a4"
  },
  //main pink dark
  PinkDark: {
    name: "D_pink",
    tmId: 91,
    primary: "#911B7C",
    secondary: "#C8087F",
    tertiary: "#a8569a",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9e9e9e',
    tableBGColor: '#E6CED7',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#a84c98",
    shadow2: "#cc4599",
    shadow3: "#db7bcb",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#e8e9eb",
    sideBar1: "#C8087F",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    activeRow: "#d751a4",
    papperBg: "#121212",
    FontClr: "#fff",
  },
  Green: {
    name: "green",
    tmId: 2,
    // primary : "#057d86",
    // primary : "#30d5c8",
    // primary : "#396afc",
    primary: "#2e858b",
    // secondary : "#53b983",
    secondary: "#5fb7b7",//2^1 #55b1b8
    tertiary: "#71acb1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    // dark : "#212121",
    // dark:"#474747",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    // muted : "#757575",
    // border : "#9e9e9e",
    // inverse : "#616161",
    // shaft : "",
    // dove_gray : "",  
    // body_bg : "",
    /////////////////
    //// solid colors 
    /////////////////
    white: "#fff",
    black: "#000",
    shadow1: "#56A1A6",
    shadow2: "#73C6CC",
    shadow3: "#74afb3",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#DFF0EA",
    sideBar1: "#2e858b",
    // sideBar1: "#000",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    papperBg: "#fff",
    activeRow: "#5fb7b7",
  },
  GreenDark: {
    name: "D_green",
    tmId: 92,
    // primary : "#057d86",
    // primary : "#30d5c8",
    // primary : "#396afc",
    primary: "#2e858b",
    // secondary : "#53b983",
    secondary: "#5fb7b7",//2^1 #55b1b8
    tertiary: "#71acb1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    // dark : "#212121",
    // dark:"#474747",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    // muted : "#757575",
    // border : "#9e9e9e",
    // inverse : "#616161",
    // shaft : "",
    // dove_gray : "",  
    // body_bg : "",
    /////////////////
    //// solid colors 
    /////////////////
    white: "#fff",
    black: "#000",
    shadow1: "#56A1A6",
    shadow2: "#73C6CC",
    shadow3: "#74afb3",
    bodyGray: "#26262F",
    bodyGray1: "#121212",
    bodyGray2: "#373843",
    primaryRow: "#DFF0EA",
    sideBar1: "#2e858b",
    // sideBar1: "#000",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    FontClr: "#fff",
    papperBg: "#121212",
    activeRow: "#5fb7b7"
  },
  Green1: {
    name: "green",
    tmId: 20,
    // primary : "#057d86",5B9C7C
    primary: "#51a8af",//51a8af
    // primary: "#55b1b8",
    // primary: "#2e858b",
    secondary: "#70b2ad",//#9ABCAF,
    // secondary: "#8CB2AD",//2^1 #55b1b8
    tertiary: "#71acb1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    // dark : "#212121",
    // dark:"#474747",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    // muted : "#757575",
    // border : "#9e9e9e",
    // inverse : "#616161",
    // shaft : "",
    // dove_gray : "",  
    // body_bg : "",
    /////////////////
    //// solid colors 
    /////////////////
    white: "#fff",
    black: "#000",
    shadow1: "#56A1A6",
    shadow2: "#82b1b4",
    shadow3: "#74afb3",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#DFF0EA",
    sideBar1: "#2e858b",
    // sideBar1: "#000",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    papperBg: "#fff",
    activeRow: "#5fb7b7",
  },
  Green1Dark: {
    name: "D_green",
    tmId: 920,
    // primary : "#057d86",5B9C7C
    primary: "#51a8af",//51a8af
    // primary: "#55b1b8",
    // primary: "#2e858b",
    secondary: "#70b2ad",//#9ABCAF,
    // secondary: "#8CB2AD",//2^1 #55b1b8
    tertiary: "#71acb1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    // dark : "#212121",
    // dark:"#474747",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    // muted : "#757575",
    // border : "#9e9e9e",
    // inverse : "#616161",
    // shaft : "",
    // dove_gray : "",  
    // body_bg : "",
    /////////////////
    //// solid colors 
    /////////////////
    white: "#fff",
    black: "#000",
    shadow1: "#56A1A6",
    shadow2: "#82b1b4",
    shadow3: "#74afb3",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#DFF0EA",
    sideBar1: "#2e858b",
    // sideBar1: "#000",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    FontClr: "#fff",
    papperBg: "#121212",
    activeRow: "#5fb7b7"
  },
  Purple: {
    name: "purple",
    tmId: 3,
    primary: "#a082ad",
    secondary: "#a082ad",
    tertiary: "#8f68a1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    // inputFieldBorderColor: '#e2e4ee',
    tableBGColor: '#E8E0EC',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#9554b3",
    shadow2: "#a777bf",
    shadow3: "#d2a0e8",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#DFD6EF",
    sideBar1: "#a082ad",
    // sideBar1: "#7a5a8a",
    // #7a5a8a
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    papperBg: "#fff",
    activeRow: "#9b6ab7",
  },
  PurpleDark: {
    name: "D_purple",
    tmId: 93,
    primary: "#a082ad",
    secondary: "#a082ad",
    tertiary: "#8f68a1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9E9E9E',
    tableCellHeadColor: "#000",
    // inputFieldBorderColor: '#e2e4ee',
    tableBGColor: '#dccfe3',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#9554b3",
    shadow2: "#a777bf",
    shadow3: "#d2a0e8",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#DFD6EF",
    // sideBar1: "#75428C",
    sideBar1: "#a082ad",
    // #7a5a8a
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    FontClr: "#fff",
    papperBg: "#121212",
    activeRow: "#9b6ab7",
  },
  Purple1: {
    name: "purple",
    tmId: 30,
    primary: "#8c62a0",
    secondary: "#ac89bc",
    tertiary: "#8f68a1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    // inputFieldBorderColor: '#e2e4ee',
    tableBGColor: '#E8E0EC',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#a389b1",
    shadow2: "#a984bc",
    shadow3: "#d2a0e8",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#DFD6EF",
    sideBar1: "#75428C",
    // sideBar1: "#7a5a8a",
    // #7a5a8a
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    activeRow: "#9b6ab7",
    papperBg: "#fff",
    linkClr: "#1d79ff",
  },
  Purple1Dark: {
    name: "purple",
    tmId: 930,
    primary: "#8c62a0",
    secondary: "#ac89bc",
    tertiary: "#8f68a1",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9E9E9E',
    // inputFieldBorderColor: '#e2e4ee',
    tableBGColor: '#dccfe3',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#a389b1",
    shadow2: "#a984bc",
    shadow3: "#d2a0e8",
    bodyGray2: "#373843",
    bodyGray: "#26262F",
    bodyGray1: "#121212",
    primaryRow: "#DFD6EF",
    sideBar1: "#75428C",
    // sideBar1: "#7a5a8a",
    // #7a5a8a
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    activeRow: "#9b6ab7",
    papperBg: "#121212",
    FontClr: "#fff"
  },
  Blue: {
    name: "blue",
    tmId: 4,
    // primary: "#3a6afc",
    primary: "#3c62d6",
    // secondary: "#22c2f5",
    // secondary: "#32b2db",
    // tertiary: "#436ED6",
    secondary: "#2c6fbb",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#c6d9f7",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#496bd1",
    shadow2: "#05617e",
    shadow3: "#6a7eb8",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#e8e9eb",
    sideBar1: "#3a6afc",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    papperBg: "#fff",
    activeRow: "#32b2db",
  },
  BlueDark: {
    name: "D_blue",
    tmId: 94,
    // primary: "#3a6afc",
    primary: "#3c62d6",
    // secondary: "#22c2f5",
    secondary: "#32b2db",
    // tertiary: "#436ED6",
    secondary: "#2c6fbb",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#424242",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#496bd1",
    shadow2: "#05617e",
    shadow3: "#6a7eb8",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#e8e9eb",
    sideBar1: "#3a6afc",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    activeRow: "#32b2db",
    papperBg: "#121212",
    FontClr: "#fff",
  },
  Blue1: {
    name: "blue1",
    tmId: 40,
    primary: "#3a6afc",
    // primary: "#3c62d6",
    secondary: "#22c2f5",
    // secondary: "#32b2db",
    tertiary: "#436ED6",
    // secondary: "#2c6fbb",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#c6d9f7",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#496bd1",
    shadow2: "#13b8ed",
    shadow3: "#6a7eb8",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#e8e9eb",
    sideBar1: "#3a6afc",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    papperBg: "#fff",
    activeRow: "#32b2db",
  },
  Blue1Dark: {
    name: "D_blue1",
    tmId: 940,
    primary: "#3a6afc",
    // primary: "#3c62d6",
    secondary: "#22c2f5",
    // secondary: "#32b2db",
    tertiary: "#436ED6",
    // secondary: "#2c6fbb",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#eaeff4',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#cedafd',
    tableBGColor1: "#424242",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#496bd1",
    shadow2: "#13b8ed",
    shadow3: "#6a7eb8",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#e8e9eb",
    sideBar1: "#3a6afc",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
    activeRow: "#32b2db",
    papperBg: "#121212",
    FontClr: "#fff",
  },
  Dblue: {
    name: "Dblue",
    tmId: 5,
    primary: "#13338F",
    // primary: "#3a6afc",
    // secondary: "#22c2f5",
    secondary: "#2c6fbb",
    tertiary: "#447fc2",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#D3E3FD',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#3e5bb3",
    shadow2: "#068eba",
    shadow3: "#6a7eb8",
    bodyGray: "#eeeefa",
    bodyGray2: "#ffff",
    bodyGray1: "#F8FBFF",
    primaryRow: "#e8e9eb",
    sideBar1: "#3a6afc",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
  },
  Dblue1: {
    name: "Dblue",
    tmId: 50,
    primary: "#1e1f26",
    // primary: "#3a6afc",
    // secondary: "#22c2f5",
    secondary: "#283655",
    tertiary: "#4d648d",
    forth: "#d0e1f9",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#9E9E9E',
    tableBGColor: '#D3E3FD',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#fff",
    black: "#000",
    shadow1: "#3e5bb3",
    shadow2: "#068eba",
    shadow3: "#6a7eb8",
    bodyGray: "#26262F",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#e8e9eb",
    sideBar1: "#3a6afc",
    sideBarIcon: "#fffff",
    nav: "#F2F5F7",
    navF: "#293845",
    linkClr: "#1d79ff",
  },
  aDblue: {
    name: "dark",
    tmId: 6,
    primary: "#662D80",
    secondary: "#8C62A0",
    tertiary: "#a8569a",
    forth: "#8C62A0",
    success: "#34994f",
    info: "#268DDD",
    danger: "#e55353",
    warning: "#f9a825",
    light: "#f8fbfb",
    inputFieldColor: '#364d64',
    inputFieldBorderColor: '#e2e4ee',
    tableBGColor: '#f8acc9',
    tableBGColor1: "#B296BF",
    tableBGColor2: `rgb(227, 227, 227)`,
    tableCellHeadColor: "#000",
    inputLabelColor: 'rgba(0, 0, 0, 0.6)',
    white: "#1E1E1E",
    black: "#000",
    shadow1: "#a84c98",
    shadow2: "#cc4599",
    shadow3: "#db7bcb",
    bodyGray: "#3C3C42",
    bodyGray2: "#373843",
    bodyGray1: "#121212",
    primaryRow: "#e8e9eb",
    sideBar1: "#662D80",
    sideBarIcon: "#fffff",
    nav: "#292929",
    navF: "white",
    linkClr: "#1d79ff",
  },

}

export default Colour;
